<div class="login">
  <div class="side-image"></div>
  <div class="login-form" [ngSwitch]="mode">
    <form
      [formGroup]="loginForm"
      (ngSubmit)="onSubmit($event)"
      *ngSwitchCase="'login'"
    >
      <div class="title">
        <img
          style="width: 150px"
          src="assets/img/everight-logo-small.png"
          alt="logo"
        />
      </div>
      <div class="form">
        <div class="input">
          <mat-form-field class="example-full-width">
            <mat-label>User Name</mat-label>
            <input
              formControlName="username"
              type="text"
              matInput
              placeholder="example@gmail.com"
            />
          </mat-form-field>
        </div>
        <div class="input">
          <span style="position: relative">
            <mat-form-field class="example-full-width">
              <mat-label>Password</mat-label>
              <input
                *ngIf="!show"
                formControlName="password"
                type="password"
                matInput
                placeholder="***********"
              />
              <input
                *ngIf="show"
                formControlName="password"
                type="text"
                matInput
                placeholder="***********"
              />
            </mat-form-field>
            <img
              (click)="switch()"
              style="cursor: pointer; position: absolute; top: 0; right: 20px"
              src="assets/icons/show.svg"
              alt=""
            />
          </span>
          <div style="margin-bottom: 20px">
            <mat-radio-group
              color="primary"
              [(ngModel)]="selected"
              [ngModelOptions]="{ standalone: true }"
            >
              <mat-radio-button style="margin-right: 20px" value="Patient"
                >Self service</mat-radio-button
              >
              <mat-radio-button value="Offline">Core System</mat-radio-button>
            </mat-radio-group>

            <!-- <div>
              <div *ngIf="showDropdown">
                <span class="input">
                  <mat-form-field>
                    <mat-label>Location</mat-label>
                    <mat-select
                      [(ngModel)]="location"
                      required
                      (selectionChange)="onLocationSelect($event.value)"
                    >
                      <mat-option value="abuja">Abuja</mat-option>
                      <mat-option value="lagos">Lagos</mat-option>
                      <mat-option value="owerri">Owerri</mat-option>
                      <mat-option value="kubwa">Kubwa</mat-option>
                      <mat-option value="kubwa">Kubwa</mat-option>
                    </mat-select>
                  </mat-form-field>
                </span>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="errorMessage">
        <div *ngIf="loginErrors" class="error">
          <p>{{ loginErrors }}</p>
        </div>
      </div>
      <div class="butto">
        <button *ngIf="!isLoading" class="btn btn-primary btn-block" color="">
          Login
        </button>
        <button *ngIf="isLoading" class="btn btn-primary btn-block" color="">
          <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
        </button>
      </div>
      <div (click)="signup()" class="signup">
        Don"t have an account?
        <span style="color: #0c5a96; cursor: pointer">sign up</span>
      </div>
    </form>

    <form
      [formGroup]="SignUpForm"
      (ngSubmit)="submit($event)"
      *ngSwitchCase="'signup'"
    >
      <div class="space"></div>
      <div class="space"></div>
      <div class="space"></div>
      <div class="title">
        <img
          style="width: 150px"
          src="assets/img/everight-logo-small.png"
          alt="logo"
        />
      </div>
      <div class="form">
        <div class="input">
          <span style="position: relative">
            <mat-form-field class="example-full-width">
              <mat-label>Password</mat-label>
              <input
                *ngIf="!show"
                formControlName="password"
                type="password"
                matInput
                placeholder="***********"
              />
              <input
                *ngIf="show"
                formControlName="password"
                type="text"
                matInput
                placeholder="***********"
              />
            </mat-form-field>
            <img
              (click)="switch()"
              style="cursor: pointer; position: absolute; top: 0; right: 20px"
              src="assets/icons/show.svg"
              alt=""
            />
          </span>
        </div>

        <div class="input">
          <mat-form-field class="example-full-width">
            <mat-label>First Name</mat-label>
            <input
              formControlName="First_Name"
              type="text"
              matInput
              placeholder=""
            />
          </mat-form-field>
        </div>

        <div class="input">
          <mat-form-field class="example-full-width">
            <mat-label>Middle Name</mat-label>
            <input
              formControlName="Middle_Name"
              type="text"
              matInput
              placeholder=""
            />
          </mat-form-field>
        </div>

        <div class="input">
          <mat-form-field class="example-full-width">
            <mat-label>Last Name</mat-label>
            <input
              formControlName="Last_Name"
              type="text"
              matInput
              placeholder=""
            />
          </mat-form-field>
        </div>

        <div class="input">
          <mat-form-field class="example-full-width">
            <mat-label>Address</mat-label>
            <input
              formControlName="Address"
              type="text"
              matInput
              placeholder=""
            />
          </mat-form-field>
        </div>

        <div class="input">
          <mat-form-field class="example-full-width">
            <mat-label>Email</mat-label>
            <input
              formControlName="Email_id"
              type="text"
              matInput
              placeholder=""
            />
          </mat-form-field>
        </div>

        <div class="input">
          <mat-form-field class="example-full-width">
            <mat-label>Mobile Number</mat-label>
            <input
              formControlName="Phone_No"
              type="number"
              matInput
              placeholder=""
            />
          </mat-form-field>
        </div>
      </div>
      <div class="errorMessage">
        <div *ngIf="loginErrors" class="error">
          <p>{{ loginErrors }}</p>
        </div>
      </div>
      <div class="butto">
        <button *ngIf="!SignLoading" class="btn btn-primary btn-block" color="">
          Sign In
        </button>
        <button *ngIf="SignLoading" class="btn btn-primary btn-block" color="">
          <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
        </button>
      </div>
      <div (click)="logins()" class="signup">
        have an account?
        <span style="color: #0c5a96; cursor: pointer">login</span>
      </div>
      <div class="space"></div>
    </form>
  </div>
</div>
